module.exports = __webpack_public_path__ + "img/somosnext.png.21fd0efd.webp";